import { Component, Injector, Input } from '@angular/core';
import { BaseComponent } from '../base-component';
import { Menu } from '../../models/rights/menu';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
    selector: 'menu-options',
    templateUrl: './menu-options.component.html'
})
export class MenuOptionsComponent extends BaseComponent {
    @Input() path: string;

    menus: Menu[];

    constructor(_injector: Injector, protected _authService: AuthenticationService) {
        super(_injector);
    }

    ngOnInit() {
        this.menus = this.getSubMenusForPath(this.path);
    }

    isActive(path) {
        return this.currentUrl.startsWith('/' + path);
    }

    changeActivePage(target: string, extra?: { queryParams: { fromRoute: string } }, hideNavigation: boolean = false) {
        const menus: Menu[] = this.getSubMenusForPath(target);

        if (!menus.length) this.navigate(target, extra, hideNavigation);
        else {
            for (var i: number = 0; i < menus.length; i++) {
                if (menus[i].isOwned === false) continue;
                this.navigate(menus[i].structurePath, extra, hideNavigation);
                break;
            }
        }
    }

    private getSubMenusForPath(path: string) {
        let menus: Menu[] = [];
        if (this._authService.menus) menus = [...this._authService.menus];

        if (path) {
            const fragments: string[] = path.split('/');

            fragments.forEach(f => {
                const matches: Menu[] = menus.filter(m => m.route === f);
                if (matches.length) menus = matches[0].subMenus;
                else menus = [];
            });
        }

        return menus.sort((a, b): number => {
            if (a.rank < b.rank) return -1;
            else if (a.rank > b.rank) return 1;
            else return 0;
        });
    }
}
